import { FileUploader } from 'ng2-file-upload';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PackageServiceService } from './service/package-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PackageComponent implements OnInit {
  displayedColumns: string[] = ['no', 'packagename', 'typeupload', 'totalfilmamount', 'price', 'action'];
  dataSource;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private _package: PackageServiceService
  ) { }

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
    this.getPackage()
  }

  getPackage() {
    this._package.getPackageAll().subscribe(packages => {
      console.log(packages);
      this.dataSource = new MatTableDataSource(packages)
      this.dataSource.paginator = this.paginator;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  dialog_addPackage() {
    const dialogRef = this.dialog.open(dialog_add_package, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getPackage()
    })
  }

  editPackage(data: any) {
    localStorage.setItem('dataEdit', JSON.stringify(data))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_edit_package, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getPackage()
      localStorage.removeItem('dataEdit')
    })
  }

  // Dialog Delete
  dialog_deletePackage(id: any): void {
    localStorage.setItem('id', id)
    const dialogRef = this.dialog.open(dialog_delete_package, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getPackage()
      localStorage.removeItem('id')
    })
  }

}

@Component({
  selector: 'dialog_add_package',
  templateUrl: 'dialog-add-package.html',
  styleUrls: ['package.component.scss']
})
export class dialog_add_package implements OnInit {
  // ceate form add
  formAdd: FormGroup;
  packageAPI = `${environment.apiUrl}/package`;
  url_api = `${environment.apiUrl}/api`;

  custom_film: boolean = false

  pre_diagnosis : any;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  type_upload: any
  constructor(
    public dialogRef: MatDialogRef<dialog_add_package>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formAddPackage()
  }

  ngOnInit() {
    this.formAdd.get('due_date').disable()
    this.get_api()
  }

  get_api(){
    this.http.get(this.url_api, this.httpOptions).subscribe(apis =>{
      // console.log(apis['message']);
      this.pre_diagnosis = apis['message']
    }, err =>{
      console.log(err);
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddPackage() {
    this.formAdd = this.formBuilder.group({
      package_name: ['', Validators.required],
      type_upload: ['', Validators.required],
      due_date: [null, Validators.required],
      total_film_amount: ['', Validators.required],
      price: ['', Validators.required],
      pre_diagnosis_selete: ['', Validators.required],
      note: ['', Validators.required],
      package_ex_id: [10, Validators.required],
      package_api_id: ['job', Validators.required],
    })
  }

  check_type_upload(type: any) {
    // console.log(type);
    this.formAdd.get('due_date').disable()
    if (type == "month") {
      this.formAdd.controls['due_date'].setValue(30)
    } else if (type == "week") {
      this.formAdd.controls['due_date'].setValue(7)
    }else if (type == "year") {
      this.formAdd.controls['due_date'].setValue(365)
    }
  }

  check_total_film(film: any){
    // console.log(film.value);
    if(film.value == 'custom'){
      this.custom_film = true
      this.formAdd.controls['total_film_amount'].setValue("")
    }else if(film.value == 'unlimit'){
      this.custom_film = false
      this.formAdd.controls['total_film_amount'].setValue("Unlimited")
    }
  }

  addPackage() {
    this.formAdd.get('type_upload').enable()
    this.formAdd.get('due_date').enable()
    // console.log(this.formAdd.value);
    if (this.formAdd.invalid) return;
    this.http.post(this.packageAPI, this.formAdd.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Add pakage success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this.formAdd.get('due_date').disable()
      this._snackBar.open('Add pakage fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_edit_package',
  templateUrl: 'dialog-edit-package.html',
  styleUrls: ['package.component.scss']
})
export class dialog_edit_package implements OnInit {
  data_edit = JSON.parse(localStorage.getItem('dataEdit'))
  // ceate form add
  formEdit: FormGroup;
  packageAPI = `${environment.apiUrl}/package`;
  url_api = `${environment.apiUrl}/api`;

  pre_diagnosis : any;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_edit_package>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formEditPackage()
  }

  ngOnInit() {
    this.setDataEdit()
    this.formEdit.get('due_date').disable()
    this.get_api()
  }

  get_api(){
    this.http.get(this.url_api, this.httpOptions).subscribe(apis =>{
      // console.log(apis['message']);
      this.pre_diagnosis = apis['message']
    }, err =>{
      console.log(err);
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formEditPackage() {
    this.formEdit = this.formBuilder.group({
      package_id: [''],
      package_name: ['', Validators.required],
      type_upload: ['', [Validators.required]],
      total_film_amount: ['', Validators.required],
      due_date: [null, Validators.required],
      price: ['', Validators.required],
      pre_diagnosis_selete: ['', Validators.required],
      note: ['', Validators.required],
    })
  }

  check_type_upload(type: any) {
    console.log(type);
    if (type == "month") {
      this.formEdit.controls['due_date'].setValue(30)
    } else if (type == "week") {
      this.formEdit.controls['due_date'].setValue(7)
    }else if (type == "year") {
      this.formEdit.controls['due_date'].setValue(365)
    }
  }

  setDataEdit() {
    this.formEdit.controls['package_id'].setValue(this.data_edit['package_id'])
    this.formEdit.controls['package_name'].setValue(this.data_edit['package_name'])
    this.formEdit.controls['type_upload'].setValue(this.data_edit['type_upload'])
    this.formEdit.controls['total_film_amount'].setValue(this.data_edit['total_film_amount'])
    this.formEdit.controls['due_date'].setValue(this.data_edit['due_date'])
    this.formEdit.controls['price'].setValue(this.data_edit['price'])
    this.formEdit.controls['pre_diagnosis_selete'].setValue(this.data_edit['pre_diagnosis_selete'])
    this.formEdit.controls['note'].setValue(this.data_edit['note'])
    // console.log(this.formEdit.value);
  }

  editPackage() {
    // console.log(this.formEdit.value);
    this.formEdit.get('due_date').enable()
    this.http.put(`${this.packageAPI}?package_id=${this.formEdit.value.package_id}`, this.formEdit.value, this.httpOptions).subscribe(res => {
      console.log(res);
      this.onNoClick()
      this._snackBar.open('Edit pakage success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Edit pakage fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_delete_package',
  templateUrl: 'dialog-delete-package.html',
  styleUrls: ['package.component.scss']
})
export class dialog_delete_package implements OnInit {
  data_id = localStorage.getItem('id')
  deleteuserAPI = `${environment.apiUrl}/package?package_id=${this.data_id}`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_delete_package>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deletePackage() {
    this.http.delete(this.deleteuserAPI, this.httpOptions).subscribe(data => {
      // console.log('Delete Success', data);
      this.onNoClick()
      this._snackBar.open('Delete pakage success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Delete pakage fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}
